import rawline100 from '../assets/fonts/rawline-100.woff2';
import rawline100i from '../assets/fonts/rawline-100i.woff2';
import rawline200 from '../assets/fonts/rawline-100.woff2';
import rawline200i from '../assets/fonts/rawline-100i.woff2';
import rawline300 from '../assets/fonts/rawline-100.woff2';
import rawline300i from '../assets/fonts/rawline-100i.woff2';
import rawline400 from '../assets/fonts/rawline-400.woff2';
import rawline400i from '../assets/fonts/rawline-400i.woff2';
import rawline500 from '../assets/fonts/rawline-500.woff2';
import rawline500i from '../assets/fonts/rawline-500i.woff2';
import rawline600 from '../assets/fonts/rawline-600.woff2';
import rawline600i from '../assets/fonts/rawline-600i.woff2';
import rawline700 from '../assets/fonts/rawline-700.woff2';
import rawline700i from '../assets/fonts/rawline-700i.woff2';
import rawline800 from '../assets/fonts/rawline-800.woff2';
import rawline800i from '../assets/fonts/rawline-800i.woff2';
import rawline900 from '../assets/fonts/rawline-900.woff2';
import rawline900i from '../assets/fonts/rawline-900i.woff2';

export const rawlineFonts = [
  {
    fontFamily: 'Rawline',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 100,
    src: `
      local('Rawline Thin'),
      url(${rawline100}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'italic',
    fontDisplay: 'swap',
    fontWeight: 100,
    src: `
      local('Rawline Thin Italic'),
      url(${rawline100i}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 200,
    src: `
      local('Rawline ExtraLight'),
      url(${rawline200}) format('woff2'),

    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'italic',
    fontDisplay: 'swap',
    fontWeight: 200,
    src: `
      local('Rawline ExtraLight Italic'),
      url(${rawline200i}) format('woff2'),

    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 300,
    src: `
      local('Rawline Light'),
      url(${rawline300}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'italic',
    fontDisplay: 'swap',
    fontWeight: 300,
    src: `
      local('Rawline Light Italic'),
      url(${rawline300i}) format('woff2'),

    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
      local('Rawline Regular'),
      url(${rawline400}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'italic',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
      local('Rawline Italic'),
      url(${rawline400i}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 500,
    src: `
      local('Rawline Medium'),
      url(${rawline500}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'italic',
    fontDisplay: 'swap',
    fontWeight: 500,
    src: `
      local('Rawline Medium Italic'),
      url(${rawline500i}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 600,
    src: `
      local('Rawline SemiBold'),
      url(${rawline600}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'italic',
    fontDisplay: 'swap',
    fontWeight: 600,
    src: `
      local('Rawline SemiBold Italic'),
      url(${rawline600i}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 700,
    src: `
      local('Rawline Bold'),
      url(${rawline700}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'italic',
    fontDisplay: 'swap',
    fontWeight: 700,
    src: `
      local('Rawline Bold Italic'),
      url(${rawline700i}) format('woff2')
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 800,
    src: `
      local('Rawline ExtraBold'),
      url(${rawline800}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'italic',
    fontDisplay: 'swap',
    fontWeight: 800,
    src: `
      local('Rawline ExtraBold Italic'),
      url(${rawline800i}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 900,
    src: `
      local('Rawline Black'),
      url(${rawline900}) format('woff2'),
    `,
  },
  {
    fontFamily: 'Rawline',
    fontStyle: 'italic',
    fontDisplay: 'swap',
    fontWeight: 900,
    src: `
      local('Rawline Black Italic'),
      url(${rawline900i}) format('woff2'),
    `,
  },
];

export default rawlineFonts;
